import React from 'react'
import { slugs } from '@/constants/slugs'
import { Translate } from '@/utils/translate/translate-client'
import {
  getProjectStyle,
  createHowPreOrdersWorkAnswer,
  createRefundPolicyAnswer,
  createContactSupportAnswer,
} from '../shared'
import { GiveawayFaq } from '../types'

export const getKingOfKingsFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) => t('kingOfKingsReleaseDateQuestion', 'When will the movie The King of Kings be in theaters?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.kingOfKings)}>
        {t('kingOfKingsReleaseDateAnswer', 'The King of Kings will open in theaters on April 11, 2025.')}
      </span>
    ),
  },
  {
    key: 'howPreOrdersWork',
    question: (t) => t('howPreOrdersWorkQuestion', 'How do pre-orders work?'),
    answer: createHowPreOrdersWorkAnswer(slugs.kingOfKings, 'KingOfKings'),
  },
  {
    key: 'matineeVsPrimetime',
    question: (t) => t('matineeVsPrimetimeQuestion', 'What are Matinee tickets vs. Primetime tickets?'),
    answer: (t) => (
      <Translate t={t} i18nKey="matineeVsPrimetimeAnswer">
        <ul className={`flex list-inside list-disc flex-col gap-2 ${getProjectStyle(slugs.kingOfKings)}`}>
          <li>
            Matinee Tickets: Redeemable for any showtimes before 4:00 p.m. on non-holiday dates.
            <ul className="ml-6 mt-2">
              <li>Holidays where matinee tickets are not valid:</li>
              <li>November 28, December 24-25, December 31, and January 1.</li>
              <li>Matinee tickets are valid on December 26 and December 30 before 4:00 p.m.</li>
            </ul>
          </li>
          <li>
            Primetime Tickets: Provide the best chance to reserve your preferred seats.
            <ul className="ml-6 mt-2">
              <li>Valid any day or time, including holidays.</li>
              <li>You can upgrade to Primetime Tickets during checkout or through promotional emails.</li>
            </ul>
          </li>
        </ul>
      </Translate>
    ),
  },
  {
    key: 'refundPolicy',
    question: (t) => t('refundPolicyQuestion', 'What is the refund policy?'),
    answer: createRefundPolicyAnswer(slugs.kingOfKings, false),
  },
  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.kingOfKings),
  },
]
